function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21 11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5L12 1L21 5V11ZM12 21C15.75 20 19 15.54 19 11.22V6.3L12 3.18L5 6.3V11.22C5 15.54 8.25 20 12 21Z",
  className: "icon-primary"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 7C14.4108 7 16.5833 8.5703 17.5 11.0008C16.8912 12.5915 15.7288 13.8536 14.2679 14.5099C12.807 15.1663 11.1671 15.1632 9.70833 14.5014C8.25874 13.8401 7.10615 12.5817 6.5 11C7.41667 8.56953 9.58917 7 12 7ZM10.2325 9.23242C10.7012 8.76318 11.337 8.5 12 8.5C12.6631 8.5 13.2989 8.76318 13.7676 9.23242C13.9712 9.43604 14.1363 9.6709 14.2574 9.92578C14.4156 10.2583 14.5 10.625 14.5 11C14.5 11.6631 14.2369 12.2988 13.7676 12.7676C13.2989 13.2368 12.6631 13.5 12 13.5C11.337 13.5 10.7012 13.2368 10.2325 12.7676C9.76322 12.2988 9.50004 11.6631 9.50004 11C9.50004 10.3369 9.76322 9.70117 10.2325 9.23242ZM12.7071 10.293C12.5196 10.1055 12.2652 10 12 10C11.9097 10 11.8204 10.0122 11.7344 10.0356C11.5689 10.0815 11.4165 10.1694 11.293 10.293C11.2369 10.3491 11.1885 10.4111 11.148 10.4775C11.0523 10.6333 11 10.814 11 11C11 11.2651 11.1055 11.5195 11.293 11.707C11.4805 11.8945 11.7349 12 12 12C12.2652 12 12.5196 11.8945 12.7071 11.707C12.8946 11.5195 13 11.2651 13 11C13 10.7349 12.8946 10.4805 12.7071 10.293Z",
  className: "icon-primary"
});

function SvgAmlFraudOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    className: "icon-primary",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmlFraudOverview);
export default __webpack_public_path__ + "static/media/aml-fraud-overview.2b68f3f0.svg";
export { ForwardRef as ReactComponent };